import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../constants/constants';
import { login02 } from '../../imagepath';

const ResendConfirmation = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = 'Моля, въведете имейл';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Невалиден имейл адрес';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/auth/resend-confirmation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: formData.email
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Изпращането не бе успешно');
      }

      alert('Нов код за потвърждение е изпратен на вашия имейл!');
      // Redirect to confirmation page with email
      navigate('/confirm-email', { state: { email: formData.email } });
    } catch (error) {
      console.error('Resend error:', error);
      setErrors({ submit: error.message || 'Възникна грешка при изпращането' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper login-body">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-lg-6 login-wrap">
            <div className="login-sec">
              <div className="log-img">
                <img className="img-fluid" src={login02} alt="Logo" />
              </div>
            </div>
          </div>

          <div className="col-lg-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="login-right">
                  <div className="login-right-wrap">
                    <h2>Изпрати нов код за потвърждение</h2>

                    <p className="text-muted mb-4">
                      Въведете вашия имейл адрес и ще ви изпратим нов код за потвърждение.
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label style={{ display: 'block', marginBottom: '8px' }}>
                          Имейл адрес <span className="login-danger">*</span>
                        </label>
                        <input
                          className={'form-control ' + (errors.email ? 'is-invalid' : '')}
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="example@email.com"
                        />
                        {errors.email && <div className="invalid-feedback d-block">{errors.email}</div>}
                      </div>

                      {errors.submit && (
                        <div className="alert alert-danger" role="alert">
                          {errors.submit}
                        </div>
                      )}

                      <div className="form-group login-btn">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? 'Изпраща се...' : 'Изпрати код'}
                        </button>
                      </div>
                    </form>

                    <div className="next-sign">
                      <p className="account-subtitle">
                        Имате код за потвърждение? <Link to="/confirm-email">Въведете код</Link>
                      </p>
                      <p className="account-subtitle">
                        Вече имате потвърден акаунт? <Link to="/login">Вход</Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResendConfirmation;
